import {useSelector} from 'react-redux';

import {IIotDeviceTargets} from '../../models/iotDevice';
import {selectIsDeviceReady} from '../../state/selectors/iotDevice';
import {makeSelectIsYapDeviceInfoReceived, makeSelectIsYapHolderInfoReceived} from '../../state/selectors/yapEncrypted';
import useFWUInfoLoaded from '../fwu/useFWUInfoLoaded';
import usePublishCheckFirmware from '../fwu/usePublishCheckFirmware';
import useFwuTargets from './useFwuTargets';

interface IProps {
    isCheckEnabled: boolean;
    forceCheck?: boolean;
    showGlobalError?: boolean;
    onError?: () => void;
}

const useCheckFirmware = (props: IProps): void => {
    const {isCheckEnabled, forceCheck, showGlobalError, onError} = props;
    const iotTargets = useIotTargets(isCheckEnabled);

    const {device: deviceFwu, holder: holderFwu} = useFWUInfoLoaded({
        iotTargets,
    });

    usePublishCheckFirmware({fwuInfo: deviceFwu, forceCheck, showGlobalError, onError});
    usePublishCheckFirmware({fwuInfo: holderFwu, forceCheck, showGlobalError, onError});
};

const useIotTargets = (isCheckEnabled: boolean): IIotDeviceTargets | undefined => {
    const isDeviceReady = useSelector(selectIsDeviceReady);
    const isYapDeviceInfoReceived = useSelector(makeSelectIsYapDeviceInfoReceived());
    const isYapHolderInfoReceived = useSelector(makeSelectIsYapHolderInfoReceived());
    const isCheckAllowed = isCheckEnabled && isDeviceReady;
    const isDeviceCheckAllowed = isCheckAllowed && isYapDeviceInfoReceived;
    const isHolderCheckAllowed = isCheckAllowed && isYapHolderInfoReceived;
    const {device, holder} = useFwuTargets();
    const resultTargets: IIotDeviceTargets = {};

    if (isDeviceCheckAllowed) {
        resultTargets.device = device;
    }
    if (isHolderCheckAllowed) {
        resultTargets.holder = holder;
    }

    return resultTargets;
};

export default useCheckFirmware;
